/**
 * Formats data for React beautiful DND
 * https://github.com/atlassian/react-beautiful-dnd
 * Expects that both params are array of objects. It will create a new
 * attribute in categories (itemIds: []) that will contain an array of Ids
 * for items that belong to that category
 * @param {Object[]} categories Container/column that's droppable, should contain an attribute named 'id'
 * @param {Object[]} items Draggable items, should contain an attribute named 'id'
 * @param {Object} options a hash containing options, expects either:
 * categoryId - the FK in items that identifies which category it belongs to
 * newAttributeName - the name of the attribute on categories that will contain the list of item Ids that belong to that category
 * @returns {Object[]} categories with new attribute of itemIds that contains items that belong to this category
 */
export function formatDndData(
  categories: { id: string | number }[],
  items: { id: string | number }[],
  options?: {
    categoryId?: string | number | undefined;
    newAttributeName?: string | undefined;
  }
) {
  // Early exit if no data
  if (
    categories === undefined ||
    categories.length === 0 ||
    items === undefined ||
    items.length === 0
  ) {
    // Handle return of undefined in caller
    return;
  }
  const categoryId =
    options && options.categoryId ? options.categoryId : "categoryId";
  const newAttributeName =
    options && options.newAttributeName ? options.newAttributeName : "itemIds";
  const newCategories = categories.map(category => {
    category[newAttributeName] = items
      .filter(item => item[categoryId] == category.id)
      .map(item => item.id);
    return category;
  });
  return newCategories;
}

/**
 * Moves element within a list from one index to another, results new list
 * @param {Array} list list that's getting modified
 * @param {number} startIndex index of current position of element being moved
 * @param {number} endIndex destination index of where item should be moved to
 * @returns {Array}
 */
export function reorderItemInArray(
  list: [],
  startIndex: number,
  endIndex: number
) {
  // Early exit if no items in list
  if (list.length === 0) {
    return;
  }
  // Remove item from list in old position and insert into new position
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
}



// WEBPACK FOOTER //
// ./app/javascript/libs/data_formatting.ts